import BuscaEscola from "@base/Inputs/BuscaEscola/BuscaEscola";

export default BuscaEscola;
